import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "../MasterDialog"

function DeleteDialog({
  title,
  show,
  handleShow,
  text1,
  cardTitle,
  buttonColor,
  handleSubmit,
  buttonText
}) {
  return (
    <CustomDialog
      title={title}
      show={show}
      handleShow={handleShow}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: 500 }}>
        <Typography paragraph variant="body">
          {text1}
        </Typography>
        <Typography paragraph variant="body_bold">
          {cardTitle.length > 1 ? cardTitle.join(", ") : cardTitle}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: buttonColor }}
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          {buttonText}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteDialog